<template>
  <component :is="tag" class="contact" v-on="$listeners">
    <div class="operator-group">
      <b-avatar
        class="merchant-profile avatar-border"
        size="42"
        :variant="isActive ? 'light-light' : 'light-primary'"
        :src="channel.merchantUserProfile"
        :text="avatarText(channel.merchantUserName)"
      >
        <img
          v-if="user.profilePicture"
          :src="user.profilePicture"
          alt="avatar"
          class="img-avatar"
        />
        <feather-icon v-else icon="UserIcon" size="22" />
      </b-avatar>
      <b-avatar
        size="42"
        class="badge-minimal customer-profile avatar-border"
        :variant="isActive ? 'light-light' : 'light-primary'"
      >
        <img :src="channel.callerUser.avatar" alt="avatar" class="img-avatar" />
      </b-avatar>
    </div>
    <div class="chat-info flex-grow-1 caller-name flex-col">
      <h5 class="mb-0 text-truncate">
        {{ channel.callerUser.name }}
      </h5>
      <p class="card-text text-truncate">
        {{ $t(`status.${channel.status}`) }}
      </p>
    </div>
    <div class="chat-meta text-nowrap date">
      <small class="d-block mb-25 chat-time">
        {{ channel.createdAt | formatShortDate }}
      </small>
      <b-badge
        v-if="channel.badgeCount"
        pill
        variant="primary"
        class="float-right"
      >
        {{ channel.badgeCount }}
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from "bootstrap-vue";
import messageType from "@/data/messageType";
import useJwt from "@/auth/jwt/useJwt";
import { useStorage } from "@vueuse/core";

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    channel: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageType,
    };
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  methods: {
    avatarText(name) {
      if (!name) return "";
      return name.charAt(0).toUpperCase();
    },
  },
  setup() {
    const user = useStorage("userData", {});

    return {
      user,
    };
  },
};
</script>

<style scoped lang="scss">
.img-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-border {
  border: 0.5px solid rgb(214, 214, 214);
}

.caller-name {
  display: flex;
  align-items: center;
}

.flex-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start !important;

  p {
    font-size: 12px;
  }
}

.contact {
  height: 65px;
}

.date {
  margin-top: 4px;
}
</style>
